/* 左边的品牌列表 */
import React, { useRef, useState, useEffect } from 'react'
import get from 'lodash/get'
import classnames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image } from 'Components/view-image'
import { ContextStore } from './reducer'

import { IConditionsProps, IInfoProps, ISortProps, ITypeConfig } from './interface'
import Link from 'next/link'

import SingleList from './single-list'

const typeConfig: ITypeConfig[] = [
  {
    "text": "汽油",
    "key": "fuel_form",
    "param": 1
  },
  {
    "text": "柴油",
    "key": "fuel_form",
    "param": 2
  },
  {
    "text": "油电混合",
    "key": "fuel_form",
    "param": 3
  },
  {
    "text": "新能源",
    "key": "fuel_form",
    "param": '4,5,6',
    'children': [
      {
        "param": "4,5,6",
        "text": "全部",
        "key": "fuel_form"
      },
      {
        "text": "纯电动",
        "key": "fuel_form",
        "param": 4
      },
      {
        "text": "增程式",
        "key": "fuel_form",
        "param": 5
      },
      {
        "text": "插电式混合动力",
        "key": "fuel_form",
        "param": 6
      }
    ]
  },
  {
    "text": "汽油+48V轻混系统",
    "key": "fuel_form",
    "param": 13
  },
]

interface IProps {
  handleOptionClick: (item: ISortProps, line: number, clearLine?: number) => void
  isOptionActive: (option: ISortProps, line: number) => boolean
}

const fuel_line = 6;

export default function FuelForm({ handleOptionClick, isOptionActive }: IProps) {
  const { state, dispatch } = React.useContext(ContextStore)

  function isFuelFormActive(item: ISortProps) {
    if (!state.fuel_form) {
      return false;
    }
    const param: string = state.fuel_form?.[0]?.['param'] + ''
    const itemParam: string = item.param + ''
    if (itemParam?.indexOf(',') > -1) {
      if (itemParam?.indexOf(param) > -1) {
        return true
      }
    } else {
      if (itemParam === param) {
        return true
      }
    }
    return false
  }

  function outterDetailValue(item: ISortProps) {
    if (!state.fuel_form) {
      return '';
    }
    if (state.fuel_form) {
      return state.fuel_form[0]['param']
    }
  }

  function renderLetters() {
    return (
      <div className="tw-flex">
        <div
          key={'x'}
          className={classnames('item-child nolimit-mr nolimit-width', {
            active: !state.fuel_form,
          })}
          onClick={() => {
            handleOptionClick({
              "param": "x",
              "text": "不限",
              "key": 'fuel_form'
            }, fuel_line)
          }}
        >不限</div>
        <ul className="fuel-wrap">
          {typeConfig.map((fuel_form: any) => (
            <li
              key={fuel_form.param}
              className={classnames((`item-child big-mr fuel-child fuel-child-${fuel_form.param}`), {
                active: isFuelFormActive(fuel_form),
                hasChildren: fuel_form?.children?.length
              })}
              onClick={(e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
                e.preventDefault()
                e.stopPropagation()
                sendTeaCommEvent('click_brand_initial_index', {
                  initial: 'letter',
                })
                handleOptionClick({
                  "param": fuel_form.param,
                  "text": fuel_form.text,
                  "key": fuel_form.key
                }, fuel_line)
              }}
            >
              <span className={`fuel-type`}>{fuel_form.text}</span>
              {
                fuel_form?.children?.length && (
                  <div className="fuel-children" >
                    <SingleList options={fuel_form?.children}
                      onChange={(item) => {
                        handleOptionClick({
                          "param": item.param,
                          "text": item.text,
                          "key": item.key
                        }, fuel_line)
                        return
                      }}
                      value={outterDetailValue(fuel_form)} />
                  </div>
                )
              }
            </li>
          ))}
        </ul>
        <style jsx>
          {`
              .nolimit-mr{
                margin-right: 30px !important;
              }
              .nolimit-width{
              }
              li{
                position: relative;
              }
              .after.active:after{
                content: '';
                position: absolute;
                width: 0;
                height: 0;
                bottom: -15px;
                left: 50%;
                transform: translate(-50%, 0);
                border-right: 7px solid transparent;
                border-left: 7px solid transparent;
                border-bottom: 9px solid #f7f8fc;
              }
              .hasChildren{
                position: relative;
              }
              .hasChildren:hover:after{
                transform: rotate(180deg)
              }
              .hasChildren:after{
                content: '';
                position: absolute;
                width: 0;
                height: 0;
                top: 13px;
                right: 6px;
                border-right: 4px solid transparent;
                border-left: 4px solid transparent;
                border-top: 5px solid #1f2129;
                transition: all 0.1s ease-in-out;
              }
              .fuel-children{
                position: absolute;
                background: #f7f8fc;
                left: 0;
                top: 28px;
                display:none;
                z-index: 99;
              }
              .fuel-children:hover{
                display:block;
              }
              .fuel-child{
                padding: 4px 8px;
              }
              .hasChildren .fuel-type{
                padding-right: 12px;
              }
              .fuel-child:hover{
                background: rgba(255, 225, 0, 0.2);
              }
              .hasChildren:hover .fuel-children{
                display: block;
              }
            `}
        </style>
      </div>
    )
  }

  return (
    <div className="item-wrap">
      <p className="name">能源</p>
      <div className="item-list">
        {renderLetters()}
      </div>
    </div>
  )
}
